import { render } from "./AwardsSlider.vue?vue&type=template&id=a006c0ee&scoped=true"
import script from "./AwardsSlider.vue?vue&type=script&lang=js"
export * from "./AwardsSlider.vue?vue&type=script&lang=js"

import "./AwardsSlider.vue?vue&type=style&index=0&id=a006c0ee&scoped=true&lang=scss"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a006c0ee"]])

export default __exports__